<template>
  <d-modal
    v-if="isVisible"
    @close="cancel">
    <d-modal-header>
      <d-modal-title>
        <template v-if="mode === 'add'">
          Add note
        </template>
        <template v-if="mode === 'edit'">
          Update note
        </template>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div class="form-group">
        <label for="note">Note:</label>
        <d-textarea
          v-model="note"
          :value.prop="note"
          rows="6"></d-textarea>
      </div>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        v-if="mode === 'edit'"
        theme="danger"
        :disabled="submitInProgress || deleteInProgress"
        @click.prevent="remove">
        Remove note
      </d-button>
      <d-button
        theme="success"
        class="ml-auto"
        :disabled="submitInProgress"
        @click.prevent="save">
        <template v-if="mode === 'add'">
          Save note
        </template>
        <template v-if="mode === 'edit'">
          Update note
        </template>
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'calendar-aircraft-note-popup',
  data () {
    return {
      isVisible: false,
      mode: 'add',
      id: 0,
      note: '',
      deleteInProgress: false,
      submitInProgress: false
    };
  },
  mounted () {
    this.$bus.$on('calendar-aircraft-note-popup-show', this.showPopup);
  },
  methods: {
    showPopup (itemData = false) {
      this.isVisible = true;

      if (!itemData.note) {
        this.mode = 'add';
        this.id = itemData.id;
        this.note = '';
      } else {
        this.mode = 'edit';
        this.id = itemData.id;
        this.note = itemData.note;
      }
    },
    cancel () {
      this.isVisible = false;
    },
    save () {
      let dataToSend;
      let endpointUrl = '/aircrafts/update-calendar-notes/' + parseInt(this.id, 10);
      this.submitInProgress = true;

      dataToSend = {
        calendar_note: this.note
      };

      FormUtils.submitInBackground({
        $http: this.$http,
        formData: dataToSend,
        endpoint: endpointUrl,
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during saving the aircraft note. Please try again',
        successAction: () => {
          Vue.swal({
            title: 'Success',
            html: 'Aircraft note has been saved',
            icon: 'success',
            confirmButtonText: 'OK',
            buttonsStyling: true,
            timer: 1000,
            timerProgressBar: true
          });

          this.submitInProgress = false;
          this.cancel();
          this.$bus.$emit('calendar-update-aircrafts-list');
        },
        failAction: () => {
          this.submitInProgress = false;
        }
      });
    },
    remove () {
      this.deleteInProgress = true;
      let endpointUrl = '/aircrafts/delete-calendar-notes/' + parseInt(this.id, 10);

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: endpointUrl,
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during deleting the aircraft note. Please try again',
        successAction: () => {
          Vue.swal({
            title: 'Success',
            html: 'Aircraft note has been removed',
            icon: 'success',
            confirmButtonText: 'OK',
            buttonsStyling: true,
            timer: 1000,
            timerProgressBar: true
          });

          this.deleteInProgress = false;
          this.cancel();
          this.$bus.$emit('calendar-update-aircrafts-list');
        },
        failAction: () => {
          this.deleteInProgress = false;
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('calendar-aircraft-note-popup-show', this.showPopup);
  }
}
</script>
